module.exports = __webpack_public_path__ + "static/media/Adi Fresh as Amended Notice of Proposal to Revoke and Apply Conditions.4db72e9e.pdf";